// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType} from "@ngrx/effects";
import {  IdentityFailure, IdentitySuccess, InitializeCoreData } from "./actions/app.actions";
import { Observable, filter, mergeMap, of, withLatestFrom } from "rxjs";
import { Store } from "@ngrx/store";
import { identityState } from "./app.state";
import { AuthService } from "../services/auth/auth.service";


@Injectable()
export class AppEffects {

    initializeCoreData$ = createEffect(() => this.actions.pipe(
        ofType(InitializeCoreData),
        withLatestFrom(this.store.select(identityState)),
        filter(([actions, identityState]) => identityState.status === 'not-checked'),
        mergeMap(([actions, identityState]) => {
            
            
            
            
            return new Observable<any>(sub => {
                this.authService.auth0?.validateToken(identityState.idToken, '', (error, result) => {
                    
                    if (error !== null) {
                        
                        sub.next(IdentityFailure({payload: undefined}))
                        //sub.complete()
                    } else {
                        
                        sub.next(IdentitySuccess({payload: result}))
                        //sub.complete()
                    }
                    sub.complete()
                })
                
            })
        } )
    ))

    // successIdentityState$ = createEffect(() => this.actions.pipe(
    //     ofType(IdentitySuccess),
    //     mergeMap(() => of(LoadPortalAuthUser({payload: undefined})))
    // ))

    // failIdentityState$ = createEffect(() => this.actions.pipe(
    //     ofType(IdentityFailure),
    //     mergeMap(() => of(AuthPortalUserFailure({payload: undefined})))
    // ))




    constructor(
        private actions: Actions, 
        private store: Store,
        private authService: AuthService,
        ) {
    }
}